export const LOCALES = ["en", "ja", "fr", "de", "it", "es", "bs"] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en";

export const LOCALE_NAMES: Record<Locale, string> = {
  en: "English",
  ja: "日本語",
  fr: "Français",
  de: "Deutsch",
  it: "Italiano",
  es: "Español",
  bs: "Bosanski",
};

export const OG_LOCALES: Record<Locale, string> = {
  en: "en_US",
  ja: "ja_JP",
  fr: "fr_FR",
  de: "de_DE",
  it: "it_IT",
  es: "es_ES",
  bs: "bs_BA",
};

export function isLocale(value: string): value is Locale {
  return (LOCALES as readonly string[]).includes(value);
}

/** Build a path with the given locale prefix; default locale has no prefix. */
export function pathForLocale(pathname: string, locale: Locale): string {
  const stripped = stripLocale(pathname);
  if (locale === DEFAULT_LOCALE) return stripped || "/";
  return `/${locale}${stripped === "/" ? "" : stripped}`;
}

/** Strip any locale prefix from a pathname, leaving the canonical (English) path. */
export function stripLocale(pathname: string): string {
  for (const locale of LOCALES) {
    if (locale === DEFAULT_LOCALE) continue;
    if (pathname === `/${locale}`) return "/";
    if (pathname.startsWith(`/${locale}/`)) return pathname.slice(locale.length + 1);
  }
  return pathname;
}
